import { w } from 'windstitch';

export const Wrapper = w.div(
  'w-full px-4 lg:px-8 lg:pr-0 md:flex items-center text-center md:text-left',
);

export const Title = w.h1('text-4xl md:text-5xl xl:text-7xl');

export const Text = w.p('text-xl lg:text-2xl mt-10 md:mt-12');

export const Image = w.img(
  'md:-mr-[445px] lg:-mr-[245px] md:h-[425px] md:min-h-[425px] md:w-[855px] md:min-w-[855px] w-full mt-10 md:mt-0'
);